import React from "react";
import Copy from "public/assets/copy.svg";
import CopyToClipboardButton from "components/Button/CopyToClipboardButton";

const SubscriptionDetailRow = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return <div className={`border-b border-white/10 py-3 ${className}`}>{children}</div>;
};

const SubscriptionDetailTitleRow = ({
  first,
  second,
}: {
  first: React.ReactNode;
  second: React.ReactNode;
}) => {
  return (
    <div className="flex items-start justify-between gap-x-4 font-medium font-semibold leading-[24px] text-white">
      <span className="min-w-0 break-words">{first}</span>
      {second}
    </div>
  );
};

const SubscriptionDetailSubtitleRow = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return <div className={`text-[13px] leading-[24px] ${className}`}>{children}</div>;
};

const CopyIcon = ({ srText }: { srText: string }) => (
  <span className="inline-flex items-center">
    <span className="sr-only">{srText}</span>
    <Copy
      className="h-6 w-6 fill-white/50 transition group-hover:fill-white/70"
      aria-hidden="true"
    />
  </span>
);

export {
  SubscriptionDetailRow,
  SubscriptionDetailTitleRow,
  SubscriptionDetailSubtitleRow,
  CopyIcon,
};
